import React, { useState, useRef, useContext } from 'react';
import { useDrag, useDrop } from 'react-dnd';
import { toast } from 'react-toastify';
// import PropTypes from 'prop-types';
import ListContext from '~/pages/Cadencia/CadenciaEdit/context';
import { Container, Block, BtAcao, ModalBody, ModalMenus } from './styles';
import history from '~/services/history';
import api from '~/services/api';

// Importando componente
import Modal from '~/components/Modal';

export default function List({ data, id, index }) {
  const ref = useRef();
  // const { move, mudarOrdem } = useContext(ListContext);
  const { move } = useContext(ListContext);
  const [idTent, setIdTent] = useState(0);
  const [isVisible, setIsVisible] = useState(false);

  // Configurando o drag in drop
  const [{ isDragging }, dragRef] = useDrag({
    item: { type: 'LIST', index },
    collect: monitor => ({
      isDragging: monitor.isDragging(),
    }),
  });

  // Configurando o drop
  const [, dropRef] = useDrop({
    accept: 'LIST',
    hover(item, monitor) {
      const draggedIndex = item.index;
      const targetIndex = index;

      if (draggedIndex === targetIndex) {
        return null;
      }

      const targetSize = ref.current.getBoundingClientRect();
      const targetCenter = (targetSize.bottom - targetSize.top) / 2;
      const draggedOffset = monitor.getClientOffset();
      const draggedTop = draggedOffset.y - targetSize.top;

      if (draggedIndex < targetIndex && draggedTop < targetCenter) {
        return null;
      }

      if (draggedIndex > targetIndex && draggedTop > targetCenter) {
        return null;
      }

      move(draggedIndex, targetIndex);

      item.index = targetIndex;
    },
  });

  dragRef(dropRef(ref));

  function handlerEditTentativa(idTents) {
    history.push(`/tentativa-edit/${id}/tentativas/${idTents}`);
  }

  function openModal(ids) {
    setIsVisible(true);
    setIdTent(ids);
  }

  function closeModal() {
    setIsVisible(false);
  }

  async function handlerDelete() {
    try {
      await api.delete(`/cadencia/${id}/tentativas/${idTent}`);
      history.push(`/cadencia-edit/${id}`);
      toast.success('Tentativa deletada com sucesso');
      setIsVisible(false);
    } catch (error) {
      toast.error('Erro ao deletar tentativa');
    }
  }

  return (
    <>
      <Container ref={ref} isDragging={isDragging}>
        <td>{data.tentativa}</td>
        <td>{data.tipo}</td>
        <td>{data.tempo} (minutos)</td>
        <td>
          <Block>
            <BtAcao type="button" onClick={() => handlerEditTentativa(data.id)}>
              Editar
            </BtAcao>
            <BtAcao inativo={1} onClick={() => openModal(data.id)}>
              Excluir
            </BtAcao>
          </Block>
        </td>
      </Container>
      {isVisible && (
        <Modal>
          <ModalBody>
            <span>Voce deseja excluir tentativa ?</span>
            <ModalMenus>
              <button type="button" onClick={handlerDelete}>
                Sim
              </button>
              <button type="button" onClick={closeModal}>
                Nao
              </button>
            </ModalMenus>
          </ModalBody>
        </Modal>
      )}
    </>
  );
}
